import React from 'react'
import PropTypes from 'prop-types'
import { LengthIcon } from 'src/components/icons'
import WithLabel from '../WithLabel'
import DurationInput from '../DurationInput'

/**
 * A [DurationInput](#DurationInput) [WithLabel](#WithLabel).
 */
const LabeledDurationInput = props => <WithLabel {...props}>{({ ...props }) => <DurationInput {...props} />}</WithLabel>

LabeledDurationInput.defaultProps = {
  icon: LengthIcon,
  color: 'light',
}

LabeledDurationInput.propTypes = {
  /**
   * The icon to display.
   */
  icon: PropTypes.elementType.isRequired,
  /**
   * The input and popup color.
   */
  color: PropTypes.string,
}

export default LabeledDurationInput
